import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import withStyles from "@material-ui/core/styles/withStyles";

import {sweetAlertOverrides} from "assets/jss/sweet-alert-overrides.jsx";

import Close from "@material-ui/icons/Close";

class SweetAlertWrapper extends React.Component {

  render() {
    const {classes} = this.props;
    return (<div className={classes.sweetAlertWrapper}>
      <div className={classes.sweetAlertWrapperInner}>
        <SweetAlert
          {...this.props}
          title={this.props.showClose ? <div style={{position: "relative"}}>{this.props.title}<a className={classes.sweetAlertClose} style={this.props.style_options ? this.props.style_options : null} onClick={this.props.onClose || this.props.onCancel}><Close/></a></div> : this.props.title}
          style={{
            display: "block",
            overflow: "visible",
            position: "initial",
            margin: "35px auto",
            left: 0,
            top: 0,
            animation: "showSweetAlertAlt 0.3s",
            maxWidth: "96vw",
            width: "450px",
            ...this.props.style
          }}
        >
          <div style={{paddingTop: 10}}>{this.props.children}</div>
        </SweetAlert>
      </div>
    </div>)
  }
}

export default withStyles(sweetAlertOverrides)(SweetAlertWrapper);
